export default __webpack_public_path__ + "static/media/YOOZ-SCAN2PAY-animated.bca34baf.mp4";